import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Heart, MapPin } from "lucide-react";
import { imageUrl, money } from "@/lib/api";
import { Stars } from "@/components/Stars";
import { useBasket } from "@/context/BasketContext";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

export function ProductCard({ product, index = 0 }) {
  const { add } = useBasket();
  const { user } = useAuth();
  const [fav, setFav] = useState(false);

  const toggleFav = async (e) => {
    e.preventDefault();
    if (!user) { toast.error("Sign in to save favourites"); return; }
    try {
      if (fav) { await api.delete(`/favourites/${product.id}`); setFav(false); }
      else { await api.post(`/favourites/${product.id}`); setFav(true); toast.success("Saved to favourites"); }
    } catch { toast.error("Could not update favourite"); }
  };

  return (
    <Link to={`/product/${product.id}`} data-testid={`product-card-${product.id}`}
      className="bg-white border border-[#E5DEC9] rounded-2xl overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col group relative animate-fade-up"
      style={{ animationDelay: `${Math.min(index * 40, 300)}ms` }}>
      <div className="relative aspect-square overflow-hidden bg-[#F4EFE6]">
        <img src={imageUrl((product.images || [])[0])} alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        {product.distance_miles != null && (
          <span className="absolute top-3 left-3 bg-white/90 backdrop-blur-md text-[#1A3C2A] text-xs font-semibold px-2.5 py-1 rounded-full shadow-sm border border-[#E5DEC9] flex items-center gap-1">
            <MapPin size={11} /> {product.distance_miles} mi
          </span>
        )}
        <button data-testid={`favourite-button-${product.id}`} onClick={toggleFav}
          className="absolute top-3 right-3 bg-white/90 hover:bg-white p-2 rounded-full shadow-md transition-colors">
          <Heart size={16} className={fav ? "fill-[#E07A5F] text-[#E07A5F]" : "text-gray-600"} />
        </button>
        {product.available === false && (
          <span className="absolute bottom-3 left-3 bg-[#22252A]/80 text-white text-xs font-semibold px-2.5 py-1 rounded-full">Unavailable</span>
        )}
      </div>
      <div className="p-3.5 sm:p-4 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display font-semibold text-[#22252A] text-sm sm:text-base leading-snug line-clamp-2">{product.name}</h3>
          <span className="font-display font-extrabold text-[#1A3C2A] text-base sm:text-lg shrink-0">{money(product.price)}</span>
        </div>
        <p className="text-xs text-[#5A626A] mt-1 truncate">{product.seller_name}{product.seller_area ? ` · ${product.seller_area.split(",")[0]}` : ""}</p>
        <div className="mt-2 flex items-center justify-between">
          <Stars rating={product.rating} count={product.review_count} />
          <button data-testid={`quick-add-${product.id}`}
            onClick={(e) => { e.preventDefault(); add(product); }}
            className="text-xs font-bold text-[#E07A5F] hover:text-[#D06447]">Add +</button>
        </div>
      </div>
    </Link>
  );
}
